/* eslint-disable import/no-unresolved */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { Image } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faBars,
  faVolumeXmark,
  faVolumeHigh,
} from '@fortawesome/free-solid-svg-icons'
import { mobilePhone, wavenet_logo } from '../asset'
import CIIcon from './CIIcon'

function BookWithVideoPreview({
  srcs,
  isMediaVisible,
  redirectImage,
  redirectVideo,
}) {
  const containerRef = useRef(null)
  const [rightIndex, setRightIndex] = useState(0)
  const wheelLockRef = useRef(false)

  const backgroundImg = srcs.find((s) => s.label === 'Background Img')
  const leftVideo = srcs.find((s) => s.label === 'Left Video')
  const [isMuted, setIsMuted] = useState(true)
  const leftVideoRef = useRef(null)

  const rightImages = srcs
    .filter((s) => s.label?.startsWith('Right Img'))
    .sort((a, b) => {
      const getNum = (label) => parseInt(label.match(/\d+$/)?.[0] || '0', 10)
      return getNum(a.label) - getNum(b.label)
    })

  const getPreviewURL = (file) => {
    if (file instanceof File) return URL.createObjectURL(file)
    if (typeof file === 'string' && file.startsWith('blob:')) return file
    return `/api/file/${file}`
  }

  const handleWheel = (e) => {
    if (wheelLockRef.current) return

    wheelLockRef.current = true
    setTimeout(() => {
      wheelLockRef.current = false
    }, 500)

    const total = rightImages.length
    if (total === 0) return

    setRightIndex((prev) => {
      if (e.deltaY > 0) return (prev + 1) % total
      return (prev - 1 + total) % total
    })
  }

  return (
    <div
      className="scroller-hide"
      style={{ maxHeight: '57.5vh', overflow: 'auto' }}
      onWheel={handleWheel}
    >
      <div className="w-100 pb-1">
        <Image
          className="position-absolute"
          src={mobilePhone}
          style={{ width: '19.5rem', right: '16%', top: '2%' }}
        />
      </div>
      <div
        className="border-bottom mb-3 d-flex"
        style={{ width: '240px', height: '55px', zIndex: '0' }}
      >
        <div className="w-80 m-auto ms-auto">
          <Image src={wavenet_logo} className="w-75 ps-3" />
        </div>
        <div className="w-20 m-auto ms-auto d-flex">
          <FontAwesomeIcon icon={faBars} className="text-end" />
        </div>
      </div>
      <div className="text-title" />
      <div className="text-line" />
      <div className="text-line" />
      <div className="text-ban1" />
      <div className="text-line" />
      <div className="text-line" />
      <div className="text-line2" />
      <div
        style={{
          objectFit: 'cover',
          height: 'auto',
          position: 'absolute',
          bottom: '12%',
          width: '240px',
          zIndex: '1000',
        }}
      >
        <div
          ref={containerRef}
          className="position-relative"
          style={{
            width: '240px',
            minHeight: 'auto',
            margin: '0 auto',
          }}
        />
      </div>
      <div className="text-line" />
      <div className="text-line" />
      <div className="text-line" />
      <div className="text-line" />
      <div className="text-line" />
      <div className="text-line" />
      <br />
      <div className="text-line" />
      <div className="text-line" />
      <div className="text-line" />
      <div className="text-line" />
      <div className="text-line" />
      <div className="text-line" />
      <div className="text-line" />
      <br />
      <div className="text-line" />
      <div className="text-line" />
      <div className="text-line" />
      <div className="text-line" />
      <div className="text-line" />

      {/* 背景區塊容器 */}
      <div
        style={{
          position: 'absolute',
          bottom: '11%',
          width: '240px',
          zIndex: 1000,
        }}
      >
        {/* 背景圖片 */}
        {isMediaVisible && backgroundImg?.file && (
          <img
            src={getPreviewURL(backgroundImg.file)}
            alt="BackgroundImg"
            style={{
              width: '100%',
              height: 'auto',
              display: 'block',
            }}
          />
        )}

        {/* LeftVideo */}
        <div
          style={{
            position: 'absolute',
            top: '30%',
            left: 0,
            width: '50%',
            height: '100%',
            zIndex: 1100,
            display: 'flex',
          }}
        >
          <div
            role="presentation"
            style={{ position: 'relative' }}
            onClick={() => {
              if (redirectVideo) window.open(redirectVideo, '_blank')
            }}
          >
            {leftVideo?.file && (
              <>
                <video
                  ref={leftVideoRef}
                  autoPlay
                  muted={isMuted}
                  loop
                  playsInline
                  style={{
                    width: '100%',
                    height: 'auto',
                    objectFit: 'cover',
                    alignSelf: 'center',
                  }}
                >
                  <source
                    src={getPreviewURL(leftVideo.file)}
                    type={leftVideo.file?.type || 'video/mp4'}
                  />
                  <track kind="captions" srcLang="en" src="" default />
                </video>
                <button
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation() // 防止冒泡導致外層開啟外連
                    e.preventDefault()
                    setIsMuted((prev) => !prev)
                  }}
                  style={{
                    position: 'absolute',
                    left: '5px',
                    bottom: '43%',
                    zIndex: 1200,
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    borderRadius: '50%',
                    width: '18px',
                    height: '18px',
                    color: 'white',
                    fontSize: '12px',
                    border: 'none',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                  aria-label={isMuted ? 'Unmute video' : 'Mute video'}
                >
                  <FontAwesomeIcon
                    icon={isMuted ? faVolumeXmark : faVolumeHigh}
                  />
                </button>
              </>
            )}
          </div>
        </div>

        {/* 右側輪播 */}
        <div
          style={{
            position: 'absolute',
            top: 0,
            right: 0,
            width: '50%',
            height: '100%',
            zIndex: 1100,
            perspective: '1000px',
            overflow: 'visible',
          }}
        >
          {rightImages.map((img, i) => {
            if (!img?.file) return null

            const isActive = i === rightIndex
            const isPast = i < rightIndex
            const isFuture = i > rightIndex

            let rotation = 0

            if (isPast) {
              rotation = 90
            } else if (isActive) {
              rotation = 0
            } else {
              rotation = 60 - (i - rightIndex) * 5
            }

            const translateZ = isActive ? 0 : -10 * (i - rightIndex)

            return (
              <img
                role="presentation"
                key={`book-img-${i}`}
                src={getPreviewURL(img.file)}
                alt={`Right ${i + 1}`}
                className="book-page"
                onClick={() => {
                  if (redirectImage) window.open(redirectImage, '_blank')
                }}
                style={{
                  position: 'absolute',
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  transition: 'transform 0.6s ease, opacity 0.6s ease',
                  opacity: isPast ? 0 : 1,
                  transform: `rotateY(${rotation}deg) translateZ(${translateZ}px)`,
                  transformOrigin: 'bottom right',
                  zIndex: 100 - i,
                  // boxShadow: !isActive
                  //   ? '0 3px 10px rgba(0,0,0,0.3)'
                  //   : '0 0 0 transparent',
                  filter: isFuture ? 'brightness(0.92) blur(0.5px)' : 'none',
                }}
              />
            )
          })}
          <CIIcon />
        </div>
      </div>
    </div>
  )
}

BookWithVideoPreview.propTypes = {
  srcs: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(File),
        PropTypes.instanceOf(Blob),
      ]),
      label: PropTypes.string,
    })
  ),
  isMediaVisible: PropTypes.bool.isRequired,
  redirectImage: PropTypes.string,
  redirectVideo: PropTypes.string,
}

BookWithVideoPreview.defaultProps = {
  srcs: [],
  redirectImage: '',
  redirectVideo: '',
}

export default BookWithVideoPreview
